module.exports = __webpack_public_path__ + "static/media/account.419d1881.svg";